<!-- 客户引流 -->
<template>
    <div
        v-if="pageData.data && !pageData.data.isSsc"
        class="section-chat-guidance"
    >
        <v-tip
            ref="qrcode"
            placement="top"
            kind="large"
            clazz="qrcode-poper-wrapper"
        >
            <template slot-scope="props">
                <QrcodePoper
                    v-if="props.data"
                    :img="props.data.qrUrl"
                />
            </template>
        </v-tip>

        <v-page-header
            title="客户引流"
            level="content"
        />
        <div
            v-if="isShowGuidanceQQBoolean"
            class="right-checkbox-block section-item-line"
        >
            <div class="section-item-label">
                <v-checkbox
                    v-model="guidanceQQBoolean"
                    label="引流至QQ接待"
                />
            </div>
        </div>
        <div
            v-if="guidanceQQBoolean"
            class="right-checkbox-block section-item-line section-item-line__graybg"
        >
            <v-tip
                ref="wayTip"
                kind="large"
                placement="left"
            >
                <reception-way-tip />
            </v-tip>
            <div class="section-item-label">
                选择接待者 <span class="required">*</span>
            </div>
            <div class="section-item-content">
                <v-radio-group
                    v-model="initData.guidanceQQType"
                >
                    <template v-if="isShowQQKfuin">
                        <v-radio
                            :value="1"
                            :disabled="disableKfuin"
                            name="webim-external"
                        >
                            企业主号接待
                            <v-icon
                                v-tip:wayTip.hover
                                name="input_question"
                                class="checkbox-line__tip"
                            />
                        </v-radio>
                        <v-icon
                            v-tip:kfuinTip.hover
                            v-if="disableKfuin"
                            name="tips"
                            class="radio-group-switch__tip"
                        />
                        <v-tip
                            ref="kfuinTip"
                            placement="right"
                        >
                            请联系经销商开通
                        </v-tip>
                    </template>
                    <v-radio
                        v-if="isShowQQKfext"
                        :value="2"
                        :class="{ 'is-not-last-child': isNotLastChild }"
                        name="webim-external"
                    >
                        员工接待
                    </v-radio>
                </v-radio-group>
            </div>
        </div>
        <div
            v-if="isShowRightGuidanceBlock"
            class="right-checkbox-block section-item-line"
        >
            <div class="section-item-label width-auto">
                <v-checkbox
                    v-model="guidanceWechatBoolean"
                    :label="'引流至' + guidanceLabel"
                />
                <v-icon
                    v-tip:guidanceTip.hover
                    name="input_question"
                    class="guidance-tip-icon"
                />
            </div>
        </div>
        <v-tip
            ref="guidanceTip"
            placement="right"
        >
            <span>引导客户扫描二维码，关注公众号/小程序、申请进群等</span>
        </v-tip>
        <div
            v-if="guidanceWechatBoolean"
            class="right-checkbox-block section-item-line section-item-line__graybg"
        >
            <div class="section-item-content">
                <div
                    v-if="guidanceWechatBoolean"
                    class="recommendation-block"
                >
                    <v-popper
                        ref="selectRecommend"
                        @visibleChange="visibleChange"
                        placement="bottom"
                    >
                        <search-tree-component
                            ref="treeSelect"
                            :select-data="recommendationData"
                            :is-single="true"
                            :placeholder="'搜索' + guidanceLabel"
                            :channel-ids="channelIds"
                            @handleSave="updateRecommendList"
                        />
                    </v-popper>
                    <div
                        v-if="!(initData.guidanceData && initData.guidanceData.key)"
                        class="none-recommend"
                    >
                        <div class="add-button-line">
                            <span
                                v-popper:selectRecommend.click
                                class="link-text"
                            >
                                <v-icon name="add" />添加
                            </span>
                        </div>
                    </div>
                    <div
                        v-else
                        class="recommend-list"
                    >
                        <div class="recommend-item">
                            <div class="recommend-item__left">
                                <img
                                    :src="initData.guidanceData.logo"
                                    alt="推荐logo"
                                    class="recommend-item__left-img"
                                >
                            </div>
                            <div class="recommend-item__right">
                                <template>
                                    <div class="recommend-name">
                                        {{ initData.guidanceData.name }}
                                    </div>
                                    <div
                                        v-tip:qrcode="initData.guidanceData"
                                        class="recommend-qr-code"
                                    />
                                </template>
                                <div class="recommend-type">
                                    {{ initData.guidanceData.type }}
                                </div>
                            </div>
                        </div>
                        <div class="recommend-list-button-row">
                            <span
                                v-popper:selectRecommend.click
                                icon="v-edit"
                                class="recommend-change-button"
                            >
                                修改
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ReceptionWayTip from '../../reception-way-tip/index';
import SearchTreeComponent from '../../search-tree-component/index';
import QrcodePoper from '../../qrcode-poper';
import { CHATWINDOWSYSTEMEVENTTIPKEY } from '../config';

export default {
    components: {
        ReceptionWayTip,
        SearchTreeComponent,
        QrcodePoper,
    },
    props: {
        value: {
            type: Object,
            default: () => {},
        },
        disableKfuin: {
            type: Boolean,
            default: false,
        },
        channelIds: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            showSystemTip: !localStorage.getItem(CHATWINDOWSYSTEMEVENTTIPKEY),
            initData: {
                guidanceQQ: 1,
                guidanceQQType: 2,
                guidanceWechat: 1,
                guidanceData: {},
            },
            pageData: Object.freeze(window.pageData),
        };
    },
    computed: {
        guidanceQQBoolean: {
            set(val) {
                this.initData.guidanceQQ = val ? 1 : 0;
            },
            get() {
                return !!this.initData.guidanceQQ;
            },
        },
        guidanceWechatBoolean: {
            set(val) {
                this.initData.guidanceWechat = val ? 1 : 0;
            },
            get() {
                return !!this.initData.guidanceWechat;
            },
        },
        recommendationData() {
            const { guidanceData } = this.initData;
            return [{ ...guidanceData }];
        },
        isShowGuidanceQQBoolean() {
            // 有 QQ主号/QQ工号时，才有此开关
            return this.channelIds.includes(1) || this.channelIds.includes(2);
        },
        isShowQQKfuin() {
            // 当有 QQ 主号时，显示此选项
            return this.channelIds.includes(1);
        },
        isShowQQKfext() {
            // 当有 QQ 工号时，显示此选项
            return this.channelIds.includes(2);
        },
        isNotLastChild() {
            return this.isShowQQKfext && !this.isShowQQKfuin;
        },
        isShowRightGuidanceBlock() {
            // 当有微信公众号 或 微信小程序 或 企业群（QQ工号）时，显示此选项
            return this.channelIds.includes(4) || this.channelIds.includes(5) || this.channelIds.includes(2);
        },
        guidanceLabel() {
            // 引流至微信公众号、微信小程序或企业群
            const labelObj = { 4: '微信公众号', 5: '小程序', 2: '企业群' };
            const label = [];
            this.channelIds.forEach((item) => {
                if (labelObj[item]) {
                    label.push(labelObj[item]);
                }
            });
            return label.join('/');
        },
    },

    watch: {
        value(nextValue) {
            this.initData = nextValue;
        },
        initData: {
            handler(newData) {
                this.$emit('input', newData);
            },
            deep: true,
        },
    },
    methods: {
        closeTip() {
            localStorage.setItem(CHATWINDOWSYSTEMEVENTTIPKEY, 1);
        },
        visibleChange(val) {
            this.$refs.treeSelect.visibleChange(val);
        },
        updateRecommendList(arrData, map) {
            const result = arrData && arrData[0] && map.get(arrData[0]);
            this.initData.guidanceData = { ...result };
        },
    },
};
</script>

<style lang="less">
@import 'style.less';
</style>
